import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { Autocomplete } from '@totalsoft/rocket-ui';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import { TextField } from '@totalsoft/rocket-ui';
import MultilineEditor from 'components/common/inputs/MultilineEditor';

const StateTransitionListItemComponent = ({ item, states, onPropertyChanged, index, validation }) => {
  const { t } = useTranslation();
  return (
    <Grid item container spacing={2}>
      <Grid item xs={12} sm={6}>
        <Autocomplete
          fullWidth
          simpleValue={true}
          label={t('AutomaticStateTransitionRules.FinalState')}
          value={item.toStateId}
          options={states}
          onChange={event => {
            onPropertyChanged('toStateId', event, index);
            onPropertyChanged('toStateName', event, index);
          }}
          isSearchable={false}
          isClearable={false}
          valueKey='documentStateId'
          labelKey='documentStateName'
          error={!isValid(validation[index].toStateId)}
          helperText={getErrors(validation[index].toStateId)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          isNumeric
          fullWidth
          value={item.orderNo}
          decimalScale={0}
          onChange={event => onPropertyChanged('orderNo', event, index)}
          label={t('AutomaticStateTransitionRules.OrderNo')}
          error={!isValid(validation[index].orderNo)}
          helperText={getErrors(validation[index].orderNo)}
        />
      </Grid>
      <Grid item xs={12} sm={12}>
        <MultilineEditor
          formulaLabel={t('AutomaticStateTransitionRules.Formula')}
          formulaPropertyName='formula'
          formulaPropertyValue={item.formula || ''}
          isReadOnly={false}
          onPropertyChanged={(event, value) => onPropertyChanged(event, value, index)}
          validation={validation[index].formula}
        ></MultilineEditor>
      </Grid>
    </Grid>
  );
};

StateTransitionListItemComponent.propTypes = {
  item: PropTypes.object.isRequired,
  states: PropTypes.array.isRequired,
  onPropertyChanged: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  validation: PropTypes.object.isRequired
};

export default StateTransitionListItemComponent;
